import PropTypes from "prop-types";
import { RECENT_SEARCH } from "../../../../constants/common/common";
import Chip from "../../../atoms/chip";
import Typography from "../../../atoms/typography";

/**
 * RecentSearch component displays a list of recent search keywords.
 * It allows users to either navigate to a recent search or remove it from the list.
 *
 * @param {Object} props - Component properties.
 * @param {Array} props.recentSearch - The list of recent search keywords and URLs.
 * @param {Function} props.setRecentSearch - Function to update the recent search list in the parent component.
 *
 * @returns {JSX.Element} The rendered RecentSearch component.
 */
const RecentSearch = ({ recentSearch, onSearchTrackEvent, isFromSearch, onClose = () => {} }) => {
  /**
   * Redirects the user to the selected recent search URL.
   *
   * @param {string} url - The URL to navigate to.
   */
  const onRedirectToRecentSearch = (url) => {
    onClose();
    window.location.href = url;
  };

  return (
    <div className={`flex w-full flex-col border-b-2 border-white ${isFromSearch ? "" : "p-16"}`}>
      <Typography
        variant="p"
        Tag="p"
        classes={isFromSearch ? `text-16 text-black-100 font-600` : `font-500 text-14 text-black-100`}
      >
        {RECENT_SEARCH}
      </Typography>
      <div className="mt-8 flex w-full flex-wrap gap-8">
        {recentSearch?.map((item) => (
          <Chip
            key={item.keyword}
            id="test"
            size="medium"
            content={item.keyword}
            color="default"
            variant="default"
            classes="bg-white-900 text-grey-500 capitalize hover:bg-gray-100 hover:text-black transition-all text-12 cursor-pointer"
            // eslint-disable-next-line react/jsx-handler-names
            onClick={() => {
              onRedirectToRecentSearch(item.url);
              onSearchTrackEvent(item.keyword, item);
            }}
          />
        ))}
      </div>
    </div>
  );
};
RecentSearch.propTypes = {
  recentSearch: PropTypes.arrayOf(
    PropTypes.shape({
      keyword: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onSearchTrackEvent: PropTypes.func,
  isFromSearch: PropTypes.bool,
  onClose: PropTypes.func,
};
export default RecentSearch;
